/* global bsBreakpoints */
(() => {
  const root = document.querySelector(".hp-events");
  // callback is called on intersection change
  const onIntersection = (entries, opts) => {
    entries.forEach((entry) =>
      entry.target.classList.toggle("visible", entry.isIntersecting)
    );
  };

  const seeScroll = () => {
    let observer = new IntersectionObserver(onIntersection, {
      root: null, // default is the viewport
      threshold: 0.1, // percentage of target's visible area. Triggers "onIntersection"
    });

    observer.observe(root);
    // observer.unobserve(entry.target);
  };
  const breakpoint = function () {
    return window
      .getComputedStyle(document.body, ":before")
      .content.replace(/\"/g, "");
  };

  const init = () => {
    if (root) {
      if (breakpoint !== "xSmall") {
        new SwiperKiller(
          "hp-events",
          { xl: 4, lg: 4, md: 2, sm: 2, xs: 1 },
          {
            sliderIndex: 1,
            paddingWrapper: 25,
            infinite: true,
            autoplay: false,
            pagination: false,
          }
        );
      }

      seeScroll();
    }
  };

  init();
})();
